module.exports = new __parcel__URL__("issue-app-skeleton.tpl.80614540.svg").toString();